import { AuthService } from './../../../core/services/auth.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SearchClaimsComponent } from '../search-claims/search-claims.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TempService } from 'src/app/core/services/temp.service';
import Swal from 'sweetalert2';
import { ClaimsService } from 'src/app/core/services/claims.service';
export interface MenuItem {
  label: string;
  icon: string;
  showOnMobile: boolean;
  showOnTablet: boolean;
  showOnDesktop: boolean;
  route: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() toggleEvent = new EventEmitter<string>();

  hospitalName: any;
  registeredId: any;

  @Input() viewMenuItems = true;
  menuItems: MenuItem[] = [
    {
      label: 'Home',
      icon: 'login',
      route: '/home',
      showOnMobile: false,
      showOnTablet: true,
      showOnDesktop: true
    },
    {
      label: 'Claims',
      icon: 'login',
      route: '/claims',
      showOnMobile: false,
      showOnTablet: true,
      showOnDesktop: true
    },
    // {
    //   label: 'Payments',
    //   icon: 'help',
    //   route: '/payments',
    //   showOnMobile: false,
    //   showOnTablet: true,
    //   showOnDesktop: true
    // },
    {
      label: 'Tariff',
      icon: 'attach_money',
      route: '/tariff',
      showOnMobile: false,
      showOnTablet: false,
      showOnDesktop: true
    },
    // ,
    // {
    //   label: 'Reports',
    //   icon: 'notes',
    //   route: '/reports',
    //   showOnMobile: false,
    //   showOnTablet: true,
    //   showOnDesktop: true
    // },
  ];

  constructor(
    public authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    public tempservice:TempService,
     public claimsService:ClaimsService,
  ) { }

  toggleValue = false;

  enableProviderLending:boolean = false;
  isProviderCredits:boolean = false;
  ngOnInit(): void {
    this.hospitalName = this.authService.currentUserValue.providerBranch.hospitalName;
    this.registeredId = this.authService.currentUserValue.providerBranch.id;
    this.isProviderCredits = localStorage.getItem('isProviderCredits') == 'true' ? true : false;
     if (this.isProviderCredits) {
      this.menuItems.push({
        label: 'Provider Credits',
        icon: 'attach_money',
        route: '/provider-config',
        showOnMobile: false,
        showOnTablet: false,
        showOnDesktop: true
      });
    }
    //   this.getNotificationsDB();
    // this.getNotificationCount();
    setTimeout(() => {
      this.enableProviderLending = localStorage.getItem('enableProviderLending') == 'true' ? true : false;
    }, 1000);
  }

  toggleNav() {
    if (this.toggleValue === false) {
      this.toggleEvent.emit('true');
      this.toggleValue = true;
      // localStorage.setItem('sidenav', 'true');
    }
    else if (this.toggleValue === true) {
      this.toggleEvent.emit('false');
      this.toggleValue = false;
    }
    // this.getNotificationCount()
  }

  searchClaims() {
    const dialogRef = this.dialog.open(SearchClaimsComponent, { data: {} });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
      }
    });
  }

  emailSupportRoute() {
    this.router.navigate(['/shared/email-support'], { skipLocationChange: true });
  }
  doctorListRoute() {
    this.router.navigate(['/shared/doctor-list'], { skipLocationChange: true });
  }

  logout() {
    this.authService.logoutService();
  }

  navigateTo(path: any) {
    this.router.navigate([path], { skipLocationChange: true });
  }

    getNotificationsDB(){
   this.tempservice.getNotifications().subscribe((res:any)=>{
   
    // this.getNotificationCount()
    },
    (err: any) => {
      // Swal.fire('', err ? err : err, 'error');
    })
  }

  count:any = 0
  getNotificationCount(){
    this.tempservice.getNotificationCount().subscribe((res:any)=>{
      this.count = res.body;
     
      },
      (err: any) => {
        // Swal.fire('', err ? err : err, 'error');
      })

  }

  sendForFinovaLogin() {
      Swal.showLoading();
      this.claimsService.sendForFinovaLogin().subscribe((data: any) => {
        Swal.close();
        // Swal.fire(data.message, '', 'info')
        window.open(data.body.redirectUrl, '_blank');
      },
        error => {
          Swal.close();
          Swal.fire(error, '', 'error')
        }
      )
    }

}
